module.exports = __webpack_public_path__ + "img/NO985621551.fc4c67f7.png";